"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_AGGREGATED_TEXT_ATTRIBUTE_VALUES = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_AGGREGATED_TEXT_ATTRIBUTE_VALUES = (0, gql_1.gql)(`
   query AggregatedTextAttributeValues(
    $productTreeNodeId: ID!,
    $catalogId: ID!,
    $filter: ProductAggregatedLabelNewFilter,
    $valueFilter: ProductAggregatedLabelNewValueFilter,
    $includeNA: Boolean,
    $sort: ProductAggregatedLabelValueNewOrderBy,
    $first: Int,
    $after: ID,
    $last: Int,
    $before: ID,
  ) {
    productTreeNode(id: $productTreeNodeId) {
      id
      productAggregatedLabelsNew(catalog: $catalogId, filter: $filter) {
        edges {
          node {
            label
            productCount
            unknownCount
            productLabelValidations {
              totalCount
            }
            values(sort: $sort, filter: $valueFilter, first: $first, after: $after, last: $last, before: $before, includeNA: $includeNA) {
              edges {
                node {
                  value
                  productCount
                  origin
                  productLabelValidations {
                    totalCount
                  }
                }
              }
              pageInfo {
                hasNextPage
                endCursor
                startCursor
              }
            }
          }
        }
      }
    }
  }
`);
